module.exports = __webpack_public_path__ + "assets/webgl/skybox.569df366.jpg";